import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestFoldersContentCountsGet = {
    path: "/folders/content/counts",
    method: RouteHttpVerb.GET
};
export { locationRestFoldersContentCountsGet };
